import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SIGNUP_URL } from '../config';
import { CheckGreen, ChevronRight } from '../components/icons';

function Hero() {
  return (
    <section className="px-6 pt-28 pb-16 lg:px-10 lg:pt-36 lg:pb-24">
      <div className="mx-auto grid max-w-[1280px] items-center gap-12 lg:grid-cols-[1fr_1.05fr] lg:gap-20">
        <div className="mk-seq">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-brand/15 bg-brand-light px-3 py-1.5 text-[0.72rem] font-bold tracking-widest text-brand uppercase">
            Business Operating System · NGN-first
          </div>
          <h1 className="font-display mb-5 text-[2.75rem] leading-[1.06] font-extrabold tracking-tight text-ink lg:text-[3.625rem]">
            Run your business
            <br />
            <span className="text-brand">
              from one connected system.
            </span>
          </h1>
          <p className="mb-8 max-w-[460px] text-[1.0625rem] leading-[1.7] text-ink-2 lg:text-[1.125rem]">
            cevop connects products, buying, stock, sales, POS, and money — so a sale at the counter updates the
            business without a second spreadsheet. Sell quickly in POS. Run and understand the business in cevop
            Business.
          </p>
          <div className="mb-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={SIGNUP_URL}
              className="inline-flex items-center justify-center rounded-xl bg-brand px-7 py-3.5 text-[0.9375rem] font-semibold text-brand-on shadow-sm transition-colors hover:bg-brand-hover"
            >
              Start free
            </a>
            <Link
              to="/pos"
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-line-strong px-7 py-3.5 text-[0.9375rem] font-semibold text-ink transition-colors hover:bg-surface-2"
            >
              See how it works
              <ChevronRight />
            </Link>
          </div>
          <div className="flex items-center gap-5 border-t border-line pt-2">
            {[
              ['Free to start', 'No card needed'],
              ['NGN-first', 'Built for Nigeria'],
              ['One system', 'Business + POS'],
            ].map(([a, b]) => (
              <div key={a} className="text-center">
                <div className="text-[0.78rem] font-semibold text-ink">{a}</div>
                <div className="text-[0.68rem] text-ink-3">{b}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="mk-glow mk-glow-a" aria-hidden />
          <div className="mk-glow mk-glow-b" aria-hidden />
          <div className="mk-float relative rounded-[1.5rem] border border-line bg-surface-2 p-5">
            <div className="mb-3 rounded-2xl border border-line bg-panel p-4 shadow-sm">
              <div className="mb-3 flex items-center justify-between">
                <span className="text-[0.7rem] font-semibold text-ink-2">Business — Today</span>
                <div className="flex items-center gap-1">
                  <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-brand" />
                  <span className="font-mono-data text-[0.62rem] text-ink-3">Live</span>
                </div>
              </div>
              <div className="mk-rows grid grid-cols-3 gap-2.5">
                {[
                  ['Sold', '₦425,000', 'This period', true],
                  ['Cash', '₦170,000', 'On hand', false],
                  ['Stock', '₦2.4m', 'When tracked', false],
                ].map(([label, val, sub, green]) => (
                  <div key={String(label)} className="rounded-xl border border-line bg-surface p-2.5">
                    <div className="mb-1 text-[0.62rem] text-ink-3">{label}</div>
                    <div className="font-display text-[0.9rem] font-bold text-ink">{val}</div>
                    <div className={`mt-0.5 text-[0.6rem] font-semibold ${green ? 'text-brand' : 'text-ink-3'}`}>
                      {sub}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl bg-inverse p-4">
              <div className="mb-3 flex items-center justify-between">
                <span className="text-[0.65rem] font-semibold tracking-wider text-inverse-fg/40 uppercase">cevop POS</span>
                <span className="font-mono-data rounded-full bg-brand/10 px-2 py-0.5 text-[0.6rem] text-brand">
                  POS open
                </span>
              </div>
              <div className="mk-rows mb-3 space-y-1.5">
                {[
                  ['Basmati Rice 5kg', '₦12,500', '1'],
                  ['Cooking Oil 2L', '₦4,200', '2'],
                  ['Sugar 1kg', '₦1,800', '1'],
                ].map(([name, price, qty]) => (
                  <div
                    key={String(name)}
                    className="flex items-center justify-between rounded-lg border border-inverse-fg/[0.06] bg-panel/[0.04] px-3 py-2"
                  >
                    <div>
                      <div className="text-[0.72rem] text-inverse-fg/75">{name}</div>
                      <div className="text-[0.6rem] text-inverse-fg/30">qty {qty}</div>
                    </div>
                    <span className="font-mono-data text-[0.72rem] font-medium text-inverse-fg">{price}</span>
                  </div>
                ))}
              </div>
              <div className="flex items-center justify-between border-t border-inverse-fg/[0.08] pt-3">
                <div>
                  <div className="mb-0.5 text-[0.6rem] tracking-wider text-inverse-fg/35 uppercase">Total</div>
                  <div className="font-display text-[1.3rem] font-extrabold text-inverse-fg">₦18,500</div>
                </div>
                <span className="rounded-xl bg-brand px-5 py-2.5 text-[0.75rem] font-bold text-brand-on">Charge</span>
              </div>
            </div>

            <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 rounded-full border border-inverse-fg/10 bg-inverse px-4 py-2 text-[0.65rem] font-semibold whitespace-nowrap text-inverse-fg shadow-lg">
              <span className="text-brand">✓</span> Sale recorded · Stock moves · Books update
            </div>
          </div>
        </div>
      </div>
      <div className="mt-16 flex justify-center" aria-hidden="true">
        <span className="mk-scroll-line" />
      </div>
    </section>
  );
}

function TrustStrip() {
  return (
    <section className="border-y border-line bg-surface-2/70 py-4">
      <div className="mx-auto flex max-w-[1280px] flex-wrap items-center justify-center gap-6 px-6 lg:gap-12 lg:px-10">
        <span className="text-[0.72rem] font-semibold tracking-widest text-ink-3 uppercase">
          Built for businesses that sell
        </span>
        <div className="hidden h-4 w-px bg-line lg:block" />
        {[
          ['2 apps', 'Business + POS'],
          ['1 ledger', 'One source of truth'],
          ['NGN-first', 'Built for Nigeria'],
          ['No card', 'To start free'],
        ].map(([val, label]) => (
          <div key={label} className="flex items-center gap-2">
            <span className="font-display text-[0.95rem] font-bold text-brand">{val}</span>
            <span className="text-[0.78rem] text-ink-3">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

function Problem() {
  return (
    <section className="px-6 py-20 lg:px-10 lg:py-28">
      <div className="mx-auto grid max-w-[1280px] items-center gap-12 lg:grid-cols-2 lg:gap-20">
        <div>
          <p className="mb-3 text-[0.72rem] font-bold tracking-widest text-brand uppercase">The problem</p>
          <h2 className="font-display mb-5 text-[2rem] leading-[1.1] font-extrabold text-ink lg:text-[2.625rem]">
            Your business generates data. Understanding it shouldn&apos;t be hard.
          </h2>
          <p className="mb-6 text-[1rem] leading-[1.7] text-ink-3">
            Most businesses manage operations across disconnected tools — a POS here, a spreadsheet there, WhatsApp
            messages for stock updates, a handwritten cash book. Nothing connects. Nothing agrees.
          </p>
          <p className="text-[1rem] leading-[1.7] text-ink-3">
            At the end of the month, the accountant reconstructs the business from scraps. The owner guesses. The stock
            count doesn&apos;t match. The cash doesn&apos;t balance.
          </p>
        </div>

        <div className="mk-stagger grid grid-cols-2 gap-3">
          <div className="rounded-2xl border border-line bg-panel p-5 shadow-sm">
            <div className="mb-4 flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-red-400" />
              <span className="text-[0.68rem] font-bold tracking-widest text-ink-3 uppercase">Before</span>
            </div>
            <div className="space-y-2.5">
              {['POS', 'Spreadsheet', 'WhatsApp', 'Cash book', 'Accountant', 'Guesswork'].map((tool, i) => (
                <div key={tool}>
                  <div className="flex items-center gap-2.5">
                    <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md bg-surface-2">
                      <span className="font-mono-data text-[0.58rem] text-ink-3">{i + 1}</span>
                    </div>
                    <span className="text-[0.78rem] font-medium text-ink-2">{tool}</span>
                  </div>
                  {i < 5 && <div className="mt-1 ml-3 h-2 w-px bg-line" />}
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl bg-inverse p-5">
            <div className="mb-4 flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-brand" />
              <span className="text-[0.68rem] font-bold tracking-widest text-brand uppercase">cevop</span>
            </div>
            <div className="space-y-2">
              {['Home', 'Stock', 'Sales', 'Buying', 'Money', 'POS'].map((item) => (
                <div
                  key={item}
                  className="rounded-lg border border-inverse-fg/[0.07] bg-panel/[0.05] px-3 py-2 text-[0.78rem] font-medium text-inverse-fg/70"
                >
                  {item}
                </div>
              ))}
              <div className="mt-3 border-t border-inverse-fg/10 pt-3">
                <div className="rounded-lg border border-brand/30 bg-brand/20 px-3 py-2.5">
                  <div className="text-[0.7rem] font-bold text-brand">One connected ledger</div>
                  <div className="mt-0.5 text-[0.62rem] text-inverse-fg/40">Everything in one place</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function System() {
  return (
    <section className="border-y border-line bg-surface-2/60 px-6 py-20 lg:px-10 lg:py-28">
      <div className="mx-auto max-w-[1280px]">
        <div className="mb-14 text-center">
          <p className="mb-3 text-[0.72rem] font-bold tracking-widest text-brand uppercase">How it works</p>
          <h2 className="font-display mb-4 text-[2rem] leading-[1.1] font-extrabold text-ink lg:text-[2.625rem]">
            One business. One connected system.
          </h2>
          <p className="mx-auto max-w-[540px] text-[1rem] leading-[1.7] text-ink-3">
            One cevop product: Business workspace for running and understanding the business, and POS for selling at
            the counter — sharing one set of books.
          </p>
        </div>

        <div className="mk-stagger mb-10 grid items-center gap-5 lg:grid-cols-[1fr_auto_1fr] lg:gap-8">
          <Link
            to="/business"
            className="mk-lift group rounded-2xl border border-line bg-panel p-7 shadow-sm hover:ring-2 hover:ring-brand/20 lg:p-8"
          >
            <div className="mb-5">
              <div className="font-display text-[1.05rem] font-bold text-ink">cevop Business</div>
              <div className="text-[0.72rem] text-ink-3">For people running it</div>
            </div>
            <div className="mb-6 space-y-2.5">
              {[
                'Home overview of the business',
                'Products and stock when you need it',
                'Sales history and registers',
                'Buying from suppliers',
                'Money in, money out, and reports',
                'Team and settings',
              ].map((f) => (
                <div key={f} className="flex items-center gap-2.5">
                  <div className="h-1.5 w-1.5 flex-shrink-0 rounded-full bg-brand" />
                  <span className="text-[0.82rem] text-ink-2">{f}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-1.5 text-[0.82rem] font-semibold text-brand transition-all group-hover:gap-3">
              Explore Business <ChevronRight />
            </div>
          </Link>

          <div className="flex items-center justify-center gap-2 lg:flex-col">
            <div className="h-px w-full flex-1 bg-gradient-to-r from-transparent via-brand/40 to-transparent lg:h-8 lg:w-px lg:flex-none lg:bg-gradient-to-b" />
            <div className="flex-shrink-0 rounded-2xl border-2 border-brand/20 bg-brand-light p-3.5 text-center">
              <div className="text-[0.6rem] leading-tight font-extrabold tracking-widest text-brand uppercase">
                One
                <br />
                Ledger
              </div>
            </div>
            <div className="h-px w-full flex-1 bg-gradient-to-r from-transparent via-brand/40 to-transparent lg:h-8 lg:w-px lg:flex-none lg:bg-gradient-to-b" />
          </div>

          <Link to="/pos" className="mk-lift group rounded-2xl bg-inverse p-7 hover:ring-2 hover:ring-brand/30 lg:p-8">
            <div className="mb-5">
              <div className="font-display text-[1.05rem] font-bold text-inverse-fg">cevop POS</div>
              <div className="text-[0.72rem] text-inverse-fg/40">For people selling</div>
            </div>
            <div className="mb-6 space-y-2.5">
              {[
                'Sell products quickly',
                'Take cash, card or transfer',
                'Open and close POS',
                'Issue receipts',
                'Handle returns and voids',
                'Track by cashier',
              ].map((f) => (
                <div key={f} className="flex items-center gap-2.5">
                  <div className="h-1.5 w-1.5 flex-shrink-0 rounded-full bg-brand" />
                  <span className="text-[0.82rem] text-inverse-fg/65">{f}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-1.5 text-[0.82rem] font-semibold text-brand transition-all group-hover:gap-3">
              Explore POS <ChevronRight />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

function MoneyFlow() {
  const steps = [
    { label: 'Receive goods from a supplier', sub: 'Buying · stock up · amount owed' },
    { label: 'Customer buys at the counter', sub: 'POS records the sale' },
    { label: 'Payment taken', sub: 'Cash, card, or transfer' },
    { label: 'Stock decreases when tracked', sub: 'Quantity updates automatically' },
    { label: 'Revenue and product cost post', sub: 'Books stay balanced' },
    { label: 'Profitability reflects the sale', sub: 'Revenue − product cost − expenses' },
  ];

  return (
    <section className="px-6 py-20 lg:px-10 lg:py-28">
      <div className="mx-auto max-w-[1280px]">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <div>
            <p className="mb-3 text-[0.72rem] font-bold tracking-widest text-brand uppercase">Connected system</p>
            <h2 className="font-display mb-4 text-[2rem] leading-[1.1] font-extrabold text-ink lg:text-[2.625rem]">
              Buy, sell, and see what you actually made.
            </h2>
            <p className="mb-8 text-[1rem] leading-[1.7] text-ink-3">
              Receive goods and cevop updates stock and what you owe. Sell those goods and cevop records the sale,
              reduces stock when you track it, books revenue and product cost, and updates profitability — without
              rebuilding the month in a spreadsheet.
            </p>
            <div className="mk-stagger space-y-1">
              {steps.map((s, i) => (
                <div key={s.label}>
                  <div className="flex items-center gap-3.5 rounded-xl border border-line bg-panel px-4 py-2.5">
                    <div className="flex-1">
                      <div className="text-[0.82rem] font-semibold text-ink">{s.label}</div>
                      <div className="text-[0.68rem] text-ink-3">{s.sub}</div>
                    </div>
                    <span className="font-mono-data rounded-md bg-brand-light px-1.5 py-0.5 text-[0.62rem] text-brand">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </div>
                  {i < steps.length - 1 && (
                    <div className="flex justify-center">
                      <div className="h-3 w-px bg-brand/20" />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl bg-inverse p-7 lg:p-8">
            <div className="mb-6 text-[0.68rem] font-bold tracking-widest text-inverse-fg/30 uppercase">
              One sale · Connected impact
            </div>
            <div className="mb-6 space-y-2.5">
              {[
                ['Sale', '₦25,000', 'Recorded'],
                ['Payment', '₦25,000 cash', 'Received'],
                ['Stock', '−1 unit', 'When tracked'],
                ['Revenue', '₦25,000', 'Booked'],
                ['Product cost', '₦15,000', 'COGS'],
                ['Gross profit', '₦10,000', 'After product cost'],
              ].map(([label, val, status]) => (
                <div
                  key={label}
                  className="flex items-center justify-between rounded-xl border border-inverse-fg/[0.06] bg-panel/[0.04] px-4 py-2.5"
                >
                  <span className="text-[0.78rem] text-inverse-fg/50">{label}</span>
                  <div className="flex items-center gap-3 text-right">
                    <span className="font-mono-data text-[0.78rem] font-medium text-inverse-fg">{val}</span>
                    <span className="min-w-[50px] text-right text-[0.62rem] font-bold text-brand">{status}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="rounded-xl border border-brand/20 bg-brand/10 px-4 py-3 text-center">
              <div className="text-[0.75rem] font-semibold text-brand">
                Know what you sold, what it cost you, what you spent running the business, and what you actually made.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Audiences() {
  const [active, setActive] = useState(0);
  const personas = [
    {
      role: 'Owner',
      q: 'Where is my money and how is the business performing?',
      answers: ['Total sales vs. target', 'Cash position right now', "What's in stock", 'Staff accountability', 'Profit and loss'],
    },
    {
      role: 'Manager',
      q: 'What happened today and what needs my attention?',
      answers: ["Today's transactions", 'Low stock alerts', 'POS variances', 'Which cashier sold what', 'Cash movements'],
    },
    {
      role: 'Cashier',
      q: 'How do I sell quickly and close cleanly?',
      answers: ['Open POS with float', 'Find products fast', 'Take any payment', 'Issue receipts', 'Close and count cash'],
    },
    {
      role: 'Accountant',
      q: 'Are the records accurate and can I reconcile?',
      answers: [
        'Every sale has a ledger entry',
        'P&L and balance sheet',
        'Exportable reports',
        'Cash vs. card vs. transfer',
        'Full audit trail',
      ],
    },
  ];

  return (
    <section className="border-y border-line bg-surface-2/60 px-6 py-20 lg:px-10 lg:py-28">
      <div className="mx-auto max-w-[1280px]">
        <div className="mb-12 text-center">
          <p className="mb-3 text-[0.72rem] font-bold tracking-widest text-brand uppercase">Who it&apos;s for</p>
          <h2 className="font-display mb-4 text-[2rem] leading-[1.1] font-extrabold text-ink lg:text-[2.5rem]">
            Built for everyone in the business.
          </h2>
          <p className="mx-auto max-w-[440px] text-[1rem] text-ink-3">
            Different roles, different questions. cevop answers all of them from the same connected system.
          </p>
        </div>

        <div className="grid items-start gap-6 lg:grid-cols-[auto_1fr] lg:gap-10">
          <div className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:pb-0">
            {personas.map((p, i) => (
              <button
                key={p.role}
                type="button"
                onClick={() => setActive(i)}
                className={`flex-shrink-0 rounded-xl px-5 py-3 text-left text-[0.875rem] font-semibold transition-all duration-150 ${
                  active === i
                    ? 'bg-inverse text-inverse-fg shadow-sm'
                    : 'border border-line bg-panel text-ink-2 hover:border-brand/30'
                }`}
              >
                {p.role}
              </button>
            ))}
          </div>

          <div key={personas[active].role} className="mk-panel rounded-2xl border border-line bg-panel p-7 shadow-sm">
            <div className="mb-5">
              <div className="font-display text-[1rem] font-bold text-ink">{personas[active].role}</div>
              <div className="text-[0.72rem] text-ink-3 italic">&quot;{personas[active].q}&quot;</div>
            </div>
            <div className="mb-3 text-[0.72rem] font-bold tracking-widest text-ink-3 uppercase">cevop answers</div>
            <div className="space-y-2">
              {personas[active].answers.map((a) => (
                <div key={a} className="flex items-center gap-3 rounded-xl border border-line bg-surface px-4 py-3">
                  <CheckGreen />
                  <span className="text-[0.85rem] font-medium text-ink">{a}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function OperatingLoop() {
  const areas = [
    ['Products', 'What you sell, with prices'],
    ['Buying', 'Suppliers, orders, and receiving'],
    ['Stock', 'Quantities when you track them'],
    ['Sales / POS', 'History in Business; selling in POS'],
    ['Money', 'Money in and out, what is owed, reports'],
    ['Performance', 'Know what you sold and what you made'],
  ] as const;
  return (
    <section className="px-6 py-16 lg:px-10 lg:py-24">
      <div className="mx-auto max-w-[1280px]">
        <p className="mb-3 text-[0.72rem] font-bold tracking-widest text-brand uppercase">How cevop works</p>
        <h2 className="font-display mb-4 text-[2rem] leading-[1.1] font-extrabold text-ink lg:text-[2.375rem]">
          One connected operating loop.
        </h2>
        <p className="mb-10 max-w-[560px] text-[1rem] leading-[1.7] text-ink-3">
          These are operating areas of the current cevop product — not eight separate apps. Start free, add what you
          sell, open POS, and see stock and money update from the same books.
        </p>
        <div className="mk-stagger grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {areas.map(([name, copy]) => (
            <div key={name} className="rounded-2xl border border-line bg-surface p-5">
              <div className="font-display text-[1.05rem] font-bold text-ink">{name}</div>
              <p className="mt-2 text-[0.85rem] leading-[1.6] text-ink-3">{copy}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <a
            href={SIGNUP_URL}
            className="inline-flex items-center justify-center rounded-xl bg-brand px-7 py-3.5 text-[0.9375rem] font-semibold text-brand-on hover:bg-brand-hover"
          >
            Start free
          </a>
          <Link
            to="/business"
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-line-strong px-7 py-3.5 text-[0.9375rem] font-semibold text-ink hover:bg-surface-2"
          >
            Explore Business
            <ChevronRight />
          </Link>
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="px-6 py-20 lg:px-10 lg:py-28">
      <div className="mx-auto max-w-[700px] text-center">
        <h2 className="font-display mb-5 text-[2.25rem] leading-[1.08] font-extrabold text-ink lg:text-[2.875rem]">
          Ready to run the business from one system?
        </h2>
        <p className="mx-auto mb-8 max-w-[480px] text-[1rem] leading-[1.7] text-ink-3">
          Start free. Add what you sell, open POS, and see stock and money follow from the same books.
        </p>
        <div className="mb-5 flex flex-col justify-center gap-3 sm:flex-row">
          <a
            href={SIGNUP_URL}
            className="inline-flex items-center justify-center rounded-xl bg-brand px-8 py-3.5 text-[0.9375rem] font-semibold text-brand-on shadow-sm transition-colors hover:bg-brand-hover"
          >
            Start free
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-line-strong px-8 py-3.5 text-[0.9375rem] font-semibold text-ink transition-colors hover:bg-surface-2"
          >
            Talk to us
          </Link>
        </div>
        <p className="text-[0.75rem] text-ink-3">No credit card required. Cancel anytime. Free plan available.</p>
      </div>
    </section>
  );
}

export function HomePage() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <Problem />
      <System />
      <MoneyFlow />
      <Audiences />
      <OperatingLoop />
      <CTA />
    </>
  );
}
